import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import numeral from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class TabelaDescontoForm extends Component {
  state = {
    registro: {
      td_idf: 0,
      td_descricao: '',
    },

    tde_percentual: 0,
    tde_comissao: 0,
    listaDescontos: [],
    carregandoForm: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaDescontos: this.props.registroSelecionado.listaDescontos
      }, () => {
        this.refs.td_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.td_descricao) || (this.state.registro.td_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    const reg = {
      td_idf: this.state.registro.td_idf,
      td_descricao: this.state.registro.td_descricao,
      listaDescontos: this.state.listaDescontos,
    }

    this.props.onSalvarClick(reg);

  };

  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };



  onNovoDesconto = () => {

    this.state.listaDescontos.push({
      tde_idf: this.state.td_idf,
      tde_seq: this.state.listaDescontos.length + 1,
      tde_percentual: parseFloat(this.state.tde_percentual),
      tde_comissao: parseFloat(this.state.tde_comissao),
    });

    this.setState({
      tde_percentual: 0,
      tde_comissao: 0,
      listaDescontos: this.state.listaDescontos
    });

  };

  onExcluirDescontoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este desconto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaDescontos = [...this.state.listaDescontos];
        const index = listaDescontos.findIndex(registro => registro.tde_seq === reg.tde_seq);
        listaDescontos.splice(index, 1);
        this.setState({
          listaDescontos,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirDescontoClick(registro)} icon="delete" />
      </Tooltip>
    );
  };



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { td_idf, td_descricao } = this.state.registro;
    const { carregandoForm, listaDescontos, tde_percentual, tde_comissao } = this.state;

    // console.log('TabelaDescontoForm: ', this.state)

    return (
      <Modal
        title={td_idf ? "Edição de Tabela de Desconto" : "Cadastro de Tabela de Desconto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row style={{ marginBottom: 20 }}>
            <Col xs={24} sm={24}>
              <span>Descrição</span>
              <InputForm
                id="td_descricao"
                ref="td_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={td_descricao}
                validator={value => Boolean(value)}
              />
            </Col>



            <div style={{}}>

              <Col xs={24} sm={16}>
                <Col xs={24} sm={8} style={{ paddingRight: 20 }}>
                  <span>Perc. Desconto</span>
                  <InputForm
                    type="number"
                    id="tde_percentual"
                    ref="tde_percentual"
                    value={tde_percentual}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{}}>
                  <span>Perc. Comissão</span>
                  <InputForm
                    type="number"
                    id="tde_comissao"
                    ref="tde_comissao"
                    value={tde_comissao}
                    onChange={this.onChange}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: 17 }}>
                  <Button
                    htmlType="button"
                    onClick={this.onNovoDesconto}
                    icon="plus"
                    className="botoesModalForm2x"
                  > Adicionar
                  </Button>
                </Col>
              </Col>

              <Col xs={24} sm={8}>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaDescontos}
                  pagination={false}
                  rowKey={(listaDescontos => listaDescontos.tde_seq)}
                >
                  <Column
                    key="tde_percentual"
                    dataIndex="tde_percentual"
                    title="Perc. Desconto"
                    render={this.renderValor}
                    width={80}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tde_comissao"
                    dataIndex="tde_comissao"
                    title="Comissão"
                    render={this.renderValor}
                    width={80}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={30}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </Col>

            </div>

          </Row>


          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TabelaDescontoForm.js